import React, { useState } from 'react';
import {
  Card,
  Table,
  Button,
  Input,
  Space,
  Tag,
  Modal,
  Form,
  message,
  Popconfirm,
  Tree,
  Switch,
  Row,
  Col,
  Statistic,
  Tooltip,
  Select,
  InputNumber,
  Divider,
} from 'antd';
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  SearchOutlined,
  ReloadOutlined,
  EyeOutlined,
  SettingOutlined,
  MenuOutlined,
  FolderOutlined,
  FileOutlined,
  LinkOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
} from '@ant-design/icons';

const { Option } = Select;

const MenuManagement: React.FC = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [detailModalVisible, setDetailModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [filterType, setFilterType] = useState('all');
  const [filterStatus, setFilterStatus] = useState('all');
  const [form] = Form.useForm();
  const [expandedRowKeys, setExpandedRowKeys] = useState<React.Key[]>([]);

  // 模拟菜单数据
  const menuData = [
    {
      id: 1,
      name: '仪表盘',
      code: 'dashboard',
      path: '/dashboard',
      icon: 'DashboardOutlined',
      type: 'menu',
      level: 1,
      sort: 1,
      status: 'active',
      parentId: null,
      description: '系统首页仪表盘',
      createTime: '2025-01-01 10:00:00',
      updateTime: '2025-10-24 14:30:00',
      children: [],
    },
    {
      id: 2,
      name: '业务管理',
      code: 'business',
      path: '/business',
      icon: 'AppstoreOutlined',
      type: 'folder',
      level: 1,
      sort: 2,
      status: 'active',
      parentId: null,
      description: '业务功能管理模块',
      createTime: '2025-01-01 10:00:00',
      updateTime: '2025-10-24 14:30:00',
      children: [
        {
          id: 21,
          name: '记忆管理',
          code: 'memory',
          path: '/memory',
          icon: 'DatabaseOutlined',
          type: 'menu',
          level: 2,
          sort: 1,
          status: 'active',
          parentId: 2,
          description: '用户记忆数据管理',
          createTime: '2025-01-01 10:00:00',
          updateTime: '2025-10-24 14:30:00',
        },
        {
          id: 22,
          name: '用户画像',
          code: 'profile',
          path: '/profile',
          icon: 'UserOutlined',
          type: 'menu',
          level: 2,
          sort: 2,
          status: 'active',
          parentId: 2,
          description: '用户画像分析管理',
          createTime: '2025-01-01 10:00:00',
          updateTime: '2025-10-24 14:30:00',
        },
        {
          id: 23,
          name: '话术管理',
          code: 'script',
          path: '/script',
          icon: 'MessageOutlined',
          type: 'menu',
          level: 2,
          sort: 3,
          status: 'active',
          parentId: 2,
          description: '智能话术配置管理',
          createTime: '2025-01-01 10:00:00',
          updateTime: '2025-10-24 14:30:00',
        },
        {
          id: 24,
          name: '智能体管理',
          code: 'agent',
          path: '/agent',
          icon: 'RobotOutlined',
          type: 'menu',
          level: 2,
          sort: 4,
          status: 'active',
          parentId: 2,
          description: 'AI智能体配置管理',
          createTime: '2025-01-01 10:00:00',
          updateTime: '2025-10-24 14:30:00',
        },
      ],
    },
    {
      id: 3,
      name: '运营管理',
      code: 'operation',
      path: '/operation',
      icon: 'BarChartOutlined',
      type: 'folder',
      level: 1,
      sort: 3,
      status: 'active',
      parentId: null,
      description: '运营数据分析模块',
      createTime: '2025-01-01 10:00:00',
      updateTime: '2025-10-24 14:30:00',
      children: [
        {
          id: 31,
          name: '知识库管理',
          code: 'knowledge',
          path: '/knowledge',
          icon: 'BookOutlined',
          type: 'menu',
          level: 2,
          sort: 1,
          status: 'active',
          parentId: 3,
          description: '知识库内容管理',
          createTime: '2025-01-01 10:00:00',
          updateTime: '2025-10-24 14:30:00',
        },
        {
          id: 32,
          name: '工作流管理',
          code: 'workflow',
          path: '/workflow',
          icon: 'NodeIndexOutlined',
          type: 'menu',
          level: 2,
          sort: 2,
          status: 'active',
          parentId: 3,
          description: '业务流程配置管理',
          createTime: '2025-01-01 10:00:00',
          updateTime: '2025-10-24 14:30:00',
        },
        {
          id: 33,
          name: '调试工具',
          code: 'debug',
          path: '/debug',
          icon: 'BugOutlined',
          type: 'menu',
          level: 2,
          sort: 3,
          status: 'active',
          parentId: 3,
          description: '系统调试和测试工具',
          createTime: '2025-01-01 10:00:00',
          updateTime: '2025-10-24 14:30:00',
        },
        {
          id: 34,
          name: '大模型管理',
          code: 'model',
          path: '/model',
          icon: 'ApiOutlined',
          type: 'menu',
          level: 2,
          sort: 4,
          status: 'active',
          parentId: 3,
          description: 'AI大模型配置管理',
          createTime: '2025-01-01 10:00:00',
          updateTime: '2025-10-24 14:30:00',
        },
        {
          id: 35,
          name: '报表管理',
          code: 'reports',
          path: '/reports',
          icon: 'FileTextOutlined',
          type: 'menu',
          level: 2,
          sort: 5,
          status: 'active',
          parentId: 3,
          description: '数据报表和分析',
          createTime: '2025-01-01 10:00:00',
          updateTime: '2025-10-24 14:30:00',
        },
      ],
    },
    {
      id: 4,
      name: '系统管理',
      code: 'system',
      path: '/system',
      icon: 'SettingOutlined',
      type: 'folder',
      level: 1,
      sort: 4,
      status: 'active',
      parentId: null,
      description: '系统配置和管理模块',
      createTime: '2025-01-01 10:00:00',
      updateTime: '2025-10-24 14:30:00',
      children: [
        {
          id: 41,
          name: '审计日志',
          code: 'audit',
          path: '/audit',
          icon: 'AuditOutlined',
          type: 'menu',
          level: 2,
          sort: 1,
          status: 'active',
          parentId: 4,
          description: '系统操作审计日志',
          createTime: '2025-01-01 10:00:00',
          updateTime: '2025-10-24 14:30:00',
        },
        {
          id: 42,
          name: '系统设置',
          code: 'settings',
          path: '/settings',
          icon: 'ToolOutlined',
          type: 'menu',
          level: 2,
          sort: 2,
          status: 'active',
          parentId: 4,
          description: '系统参数配置',
          createTime: '2025-01-01 10:00:00',
          updateTime: '2025-10-24 14:30:00',
        },
        {
          id: 43,
          name: '账号管理',
          code: 'account',
          path: '/account',
          icon: 'TeamOutlined',
          type: 'menu',
          level: 2,
          sort: 3,
          status: 'active',
          parentId: 4,
          description: '用户账号管理',
          createTime: '2025-01-01 10:00:00',
          updateTime: '2025-10-24 14:30:00',
        },
        {
          id: 44,
          name: '角色管理',
          code: 'role',
          path: '/role',
          icon: 'SafetyOutlined',
          type: 'menu',
          level: 2,
          sort: 4,
          status: 'active',
          parentId: 4,
          description: '用户角色权限管理',
          createTime: '2025-01-01 10:00:00',
          updateTime: '2025-10-24 14:30:00',
        },
        {
          id: 45,
          name: '菜单管理',
          code: 'menu',
          path: '/menu',
          icon: 'MenuOutlined',
          type: 'menu',
          level: 2,
          sort: 5,
          status: 'active',
          parentId: 4,
          description: '系统菜单配置管理',
          createTime: '2025-01-01 10:00:00',
          updateTime: '2025-10-24 14:30:00',
        },
      ],
    },
  ];

  // 扁平化菜单数据用于表格显示
  const flatMenuData = [
    ...menuData,
    ...menuData.flatMap(item => item.children || []),
  ];

  const handleAddMenu = () => {
    setSelectedRecord(null);
    form.resetFields();
    setEditModalVisible(true);
  };

  const handleEditMenu = (record: any) => {
    setSelectedRecord(record);
    form.setFieldsValue(record);
    setEditModalVisible(true);
  };

  const handleViewDetail = (record: any) => {
    setSelectedRecord(record);
    setDetailModalVisible(true);
  };

  const handleSaveMenu = async (values: any) => {
    setLoading(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      if (selectedRecord) {
        message.success('菜单更新成功！');
      } else {
        message.success('菜单创建成功！');
      }
      setEditModalVisible(false);
      form.resetFields();
    } catch (error) {
      message.error('保存失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteMenu = (record: any) => {
    if (record.children && record.children.length > 0) {
      message.error('该菜单下还有子菜单，无法删除');
      return;
    }
    message.loading('正在删除菜单...', 1);
    setTimeout(() => {
      message.success(`已删除菜单 ${record.name}`);
    }, 1000);
  };

  const handleToggleStatus = (record: any) => {
    const newStatus = record.status === 'active' ? 'inactive' : 'active';
    message.loading('正在更新状态...', 1);
    setTimeout(() => {
      message.success(`菜单 ${record.name} 已${newStatus === 'active' ? '启用' : '禁用'}`);
    }, 1000);
  };

  const handleMoveUp = (record: any) => {
    message.loading('正在上移...', 1);
    setTimeout(() => {
      message.success(`菜单 ${record.name} 已上移`);
    }, 1000);
  };

  const handleMoveDown = (record: any) => {
    message.loading('正在下移...', 1);
    setTimeout(() => {
      message.success(`菜单 ${record.name} 已下移`);
    }, 1000);
  };

  const handleBatchDelete = () => {
    if (selectedRowKeys.length === 0) {
      message.warning('请选择要删除的菜单');
      return;
    }
    message.loading('正在批量删除...', 1);
    setTimeout(() => {
      message.success(`已删除 ${selectedRowKeys.length} 个菜单`);
      setSelectedRowKeys([]);
    }, 1000);
  };

  const getTypeColor = (type: string) => {
    const colors: Record<string, string> = {
      folder: 'blue',
      menu: 'green',
      button: 'orange',
      link: 'purple',
    };
    return colors[type] || 'default';
  };

  const getTypeName = (type: string) => {
    const names: Record<string, string> = {
      folder: '文件夹',
      menu: '菜单',
      button: '按钮',
      link: '链接',
    };
    return names[type] || type;
  };

  const getStatusColor = (status: string) => {
    return status === 'active' ? 'green' : 'red';
  };

  const getStatusName = (status: string) => {
    return status === 'active' ? '启用' : '禁用';
  };

  const getIconComponent = (iconName: string) => {
    const iconMap: Record<string, React.ReactNode> = {
      DashboardOutlined: <MenuOutlined />,
      AppstoreOutlined: <FolderOutlined />,
      DatabaseOutlined: <FileOutlined />,
      UserOutlined: <FileOutlined />,
      MessageOutlined: <FileOutlined />,
      RobotOutlined: <FileOutlined />,
      BarChartOutlined: <FolderOutlined />,
      BookOutlined: <FileOutlined />,
      NodeIndexOutlined: <FileOutlined />,
      BugOutlined: <FileOutlined />,
      ApiOutlined: <FileOutlined />,
      FileTextOutlined: <FileOutlined />,
      SettingOutlined: <FolderOutlined />,
      AuditOutlined: <FileOutlined />,
      ToolOutlined: <FileOutlined />,
      TeamOutlined: <FileOutlined />,
      SafetyOutlined: <FileOutlined />,
      MenuOutlined: <FileOutlined />,
    };
    return iconMap[iconName] || <FileOutlined />;
  };

  const columns = [
    {
      title: '菜单信息',
      key: 'menuInfo',
      width: 250,
      render: (_: any, record: any) => (
        <Space>
          {getIconComponent(record.icon)}
          <div>
            <div style={{ fontWeight: 'bold' }}>
              {'　'.repeat(record.level - 1)}{record.name}
            </div>
            <div style={{ fontSize: 12, color: '#999' }}>{record.code}</div>
            <div style={{ fontSize: 12, color: '#666' }}>{record.path}</div>
          </div>
        </Space>
      ),
    },
    {
      title: '类型',
      key: 'type',
      width: 100,
      render: (_: any, record: any) => (
        <Tag color={getTypeColor(record.type)}>
          {getTypeName(record.type)}
        </Tag>
      ),
    },
    {
      title: '层级',
      key: 'level',
      width: 80,
      render: (_: any, record: any) => (
        <Tag color={record.level === 1 ? 'blue' : 'green'}>
          L{record.level}
        </Tag>
      ),
    },
    {
      title: '排序',
      key: 'sort',
      width: 80,
      render: (_: any, record: any) => (
        <div style={{ textAlign: 'center', fontWeight: 'bold' }}>
          {record.sort}
        </div>
      ),
    },
    {
      title: '状态',
      key: 'status',
      width: 100,
      render: (_: any, record: any) => (
        <Tag color={getStatusColor(record.status)}>
          {getStatusName(record.status)}
        </Tag>
      ),
    },
    {
      title: '描述',
      dataIndex: 'description',
      key: 'description',
      width: 200,
      ellipsis: true,
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
      width: 150,
    },
    {
      title: '操作',
      key: 'action',
      width: 300,
      render: (_: any, record: any) => (
        <Space>
          <Tooltip title="查看详情">
            <Button type="link" icon={<EyeOutlined />} onClick={() => handleViewDetail(record)}>
              详情
            </Button>
          </Tooltip>
          <Tooltip title="编辑菜单">
            <Button type="link" icon={<EditOutlined />} onClick={() => handleEditMenu(record)}>
              编辑
            </Button>
          </Tooltip>
          <Tooltip title="上移">
            <Button type="link" icon={<ArrowUpOutlined />} onClick={() => handleMoveUp(record)}>
              上移
            </Button>
          </Tooltip>
          <Tooltip title="下移">
            <Button type="link" icon={<ArrowDownOutlined />} onClick={() => handleMoveDown(record)}>
              下移
            </Button>
          </Tooltip>
          <Tooltip title={record.status === 'active' ? '禁用菜单' : '启用菜单'}>
            <Button 
              type="link" 
              onClick={() => handleToggleStatus(record)}
            >
              {record.status === 'active' ? '禁用' : '启用'}
            </Button>
          </Tooltip>
          <Popconfirm
            title="确定要删除这个菜单吗？"
            description="删除后无法恢复，请谨慎操作"
            onConfirm={() => handleDeleteMenu(record)}
            okText="确定"
            cancelText="取消"
          >
            <Tooltip title="删除菜单">
              <Button type="link" icon={<DeleteOutlined />} danger>
                删除
              </Button>
            </Tooltip>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const filteredData = flatMenuData.filter(item => {
    const matchesSearch = !searchText || 
      item.name.toLowerCase().includes(searchText.toLowerCase()) ||
      item.code.toLowerCase().includes(searchText.toLowerCase()) ||
      item.path.toLowerCase().includes(searchText.toLowerCase());
    
    const matchesType = filterType === 'all' || item.type === filterType;
    const matchesStatus = filterStatus === 'all' || item.status === filterStatus;
    
    return matchesSearch && matchesType && matchesStatus;
  });

  const rowSelection = {
    selectedRowKeys,
    onChange: setSelectedRowKeys,
  };

  return (
    <div style={{ padding: 24 }}>
      {/* 统计卡片 */}
      <Row gutter={16} style={{ marginBottom: 24 }}>
        <Col span={6}>
          <Card>
            <Statistic title="总菜单数" value={flatMenuData.length} />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic title="一级菜单" value={flatMenuData.filter(item => item.level === 1).length} />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic title="二级菜单" value={flatMenuData.filter(item => item.level === 2).length} />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic title="启用菜单" value={flatMenuData.filter(item => item.status === 'active').length} />
          </Card>
        </Col>
      </Row>

      <Card
        title="菜单管理"
        extra={
          <Space>
            <Button
              icon={<ReloadOutlined />}
              onClick={() => message.info('数据已刷新')}
            >
              刷新
            </Button>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={handleAddMenu}
            >
              新增菜单
            </Button>
          </Space>
        }
      >
        {/* 搜索和筛选 */}
        <div style={{ marginBottom: 16 }}>
          <Space wrap>
            <Input
              placeholder="搜索菜单名称、编码或路径"
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250 }}
            />
            <Select
              value={filterType}
              onChange={setFilterType}
              style={{ width: 120 }}
            >
              <Option value="all">全部类型</Option>
              <Option value="folder">文件夹</Option>
              <Option value="menu">菜单</Option>
              <Option value="button">按钮</Option>
              <Option value="link">链接</Option>
            </Select>
            <Select
              value={filterStatus}
              onChange={setFilterStatus}
              style={{ width: 120 }}
            >
              <Option value="all">全部状态</Option>
              <Option value="active">启用</Option>
              <Option value="inactive">禁用</Option>
            </Select>
            {selectedRowKeys.length > 0 && (
              <Popconfirm
                title={`确定要删除选中的 ${selectedRowKeys.length} 个菜单吗？`}
                onConfirm={handleBatchDelete}
                okText="确定"
                cancelText="取消"
              >
                <Button danger icon={<DeleteOutlined />}>
                  批量删除
                </Button>
              </Popconfirm>
            )}
          </Space>
        </div>

        <Table
          columns={columns}
          dataSource={filteredData}
          rowKey="id"
          rowSelection={rowSelection}
          pagination={{
            total: filteredData.length,
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
            showTotal: (total) => `共 ${total} 条记录`,
          }}
          scroll={{ x: 1200 }}
        />
      </Card>

      {/* 编辑菜单模态框 */}
      <Modal
        title={selectedRecord ? '编辑菜单' : '新增菜单'}
        open={editModalVisible}
        onCancel={() => setEditModalVisible(false)}
        footer={null}
        width={600}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSaveMenu}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="菜单名称"
                rules={[{ required: true, message: '请输入菜单名称' }]}
              >
                <Input placeholder="请输入菜单名称" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="code"
                label="菜单编码"
                rules={[{ required: true, message: '请输入菜单编码' }]}
              >
                <Input placeholder="请输入菜单编码" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="path"
                label="菜单路径"
                rules={[{ required: true, message: '请输入菜单路径' }]}
              >
                <Input placeholder="请输入菜单路径" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="icon"
                label="菜单图标"
                rules={[{ required: true, message: '请选择菜单图标' }]}
              >
                <Select placeholder="请选择菜单图标">
                  <Option value="DashboardOutlined">仪表盘</Option>
                  <Option value="AppstoreOutlined">应用</Option>
                  <Option value="DatabaseOutlined">数据库</Option>
                  <Option value="UserOutlined">用户</Option>
                  <Option value="MessageOutlined">消息</Option>
                  <Option value="RobotOutlined">机器人</Option>
                  <Option value="BarChartOutlined">图表</Option>
                  <Option value="BookOutlined">书籍</Option>
                  <Option value="NodeIndexOutlined">节点</Option>
                  <Option value="BugOutlined">调试</Option>
                  <Option value="ApiOutlined">API</Option>
                  <Option value="FileTextOutlined">文件</Option>
                  <Option value="SettingOutlined">设置</Option>
                  <Option value="AuditOutlined">审计</Option>
                  <Option value="ToolOutlined">工具</Option>
                  <Option value="TeamOutlined">团队</Option>
                  <Option value="SafetyOutlined">安全</Option>
                  <Option value="MenuOutlined">菜单</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="type"
                label="菜单类型"
                rules={[{ required: true, message: '请选择菜单类型' }]}
              >
                <Select placeholder="请选择菜单类型">
                  <Option value="folder">文件夹</Option>
                  <Option value="menu">菜单</Option>
                  <Option value="button">按钮</Option>
                  <Option value="link">链接</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="level"
                label="菜单层级"
                rules={[{ required: true, message: '请选择菜单层级' }]}
              >
                <Select placeholder="请选择菜单层级">
                  <Option value={1}>一级菜单</Option>
                  <Option value={2}>二级菜单</Option>
                  <Option value={3}>三级菜单</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="sort"
                label="排序"
                rules={[{ required: true, message: '请输入排序' }]}
              >
                <InputNumber min={1} max={999} style={{ width: '100%' }} />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            name="parentId"
            label="父级菜单"
          >
            <Select placeholder="请选择父级菜单" allowClear>
              <Option value={null}>无（顶级菜单）</Option>
              {menuData.map(item => (
                <Option key={item.id} value={item.id}>{item.name}</Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="description"
            label="菜单描述"
            rules={[{ required: true, message: '请输入菜单描述' }]}
          >
            <Input.TextArea rows={3} placeholder="请输入菜单描述" />
          </Form.Item>

          <Form.Item
            name="status"
            label="状态"
            rules={[{ required: true, message: '请选择状态' }]}
            initialValue="active"
          >
            <Switch
              checkedChildren="启用"
              unCheckedChildren="禁用"
              defaultChecked
            />
          </Form.Item>

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit" loading={loading}>
                保存
              </Button>
              <Button onClick={() => setEditModalVisible(false)}>
                取消
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>

      {/* 菜单详情模态框 */}
      <Modal
        title="菜单详情"
        open={detailModalVisible}
        onCancel={() => setDetailModalVisible(false)}
        footer={[
          <Button key="close" onClick={() => setDetailModalVisible(false)}>
            关闭
          </Button>,
        ]}
        width={600}
      >
        {selectedRecord && (
          <div>
            <Row gutter={16}>
              <Col span={8}>
                <div style={{ textAlign: 'center' }}>
                  {getIconComponent(selectedRecord.icon)}
                  <div style={{ marginTop: 8, fontWeight: 'bold', fontSize: 18 }}>{selectedRecord.name}</div>
                  <div style={{ color: '#666' }}>{selectedRecord.code}</div>
                </div>
              </Col>
              <Col span={16}>
                <div style={{ marginBottom: 16 }}>
                  <h4>基本信息</h4>
                  <p><strong>菜单名称:</strong> {selectedRecord.name}</p>
                  <p><strong>菜单编码:</strong> {selectedRecord.code}</p>
                  <p><strong>菜单路径:</strong> {selectedRecord.path}</p>
                  <p><strong>菜单类型:</strong> <Tag color={getTypeColor(selectedRecord.type)}>{getTypeName(selectedRecord.type)}</Tag></p>
                  <p><strong>菜单层级:</strong> <Tag color={selectedRecord.level === 1 ? 'blue' : 'green'}>L{selectedRecord.level}</Tag></p>
                  <p><strong>排序:</strong> {selectedRecord.sort}</p>
                  <p><strong>状态:</strong> <Tag color={getStatusColor(selectedRecord.status)}>{getStatusName(selectedRecord.status)}</Tag></p>
                </div>
                
                <div style={{ marginBottom: 16 }}>
                  <h4>描述信息</h4>
                  <p>{selectedRecord.description}</p>
                </div>

                <div>
                  <h4>时间信息</h4>
                  <p><strong>创建时间:</strong> {selectedRecord.createTime}</p>
                  <p><strong>更新时间:</strong> {selectedRecord.updateTime}</p>
                </div>
              </Col>
            </Row>
            
            {selectedRecord.children && selectedRecord.children.length > 0 && (
              <>
                <Divider />
                <div>
                  <h4>子菜单列表</h4>
                  <div style={{ maxHeight: 200, overflowY: 'auto' }}>
                    {selectedRecord.children.map((child: any, index: number) => (
                      <div key={index} style={{ 
                        padding: 8, 
                        border: '1px solid #f0f0f0', 
                        borderRadius: 4, 
                        marginBottom: 4,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                      }}>
                        <Space>
                          {getIconComponent(child.icon)}
                          <span>{child.name}</span>
                          <Tag color={getTypeColor(child.type)}>{getTypeName(child.type)}</Tag>
                          <Tag color={getStatusColor(child.status)}>{getStatusName(child.status)}</Tag>
                        </Space>
                        <span style={{ color: '#666', fontSize: 12 }}>{child.path}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>
        )}
      </Modal>
    </div>
  );
};

export default MenuManagement;
